import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enMessages from './locales/en/messages.json';
import esMessages from './locales/es/messages.json';
import frMessages from './locales/fr/messages.json';
import deMessages from './locales/de/messages.json';
import ptMessages from './locales/pt/messages.json';
import jaMessages from './locales/ja/messages.json';
import arMessages from './locales/ar/messages.json';

i18n
    .use(LanguageDetector)      // Detects user language
    .use(initReactI18next)       // Passes i18n to React
    .init({
        resources: {
            en: {
                translation: enMessages  // English (default)
            },
            es: {
                translation: esMessages  // Spanish
            },
            fr: {
                translation: frMessages  // French
            },
            de: {
                translation: deMessages  // German
            },
            pt: {
                translation: ptMessages  // Portuguese
            },
            ja: {
                translation: jaMessages  // Japanese
            },
            ar: {
                translation: arMessages  // Arabic (RTL)
            }
        },
        fallbackLng: 'en',

        // Language detection configuration
        detection: {
            order: ['navigator']
        },

        // Support language codes like 'en-US' -> 'en', 'pt-BR' -> 'pt', 'ja-JP' -> 'ja'
        load: 'languageOnly',

        interpolation: {
            escapeValue: false  // React already escapes
        }
    });

// RTL languages
const rtlLanguages = ['ar'];

// Helper function to update HTML lang and dir attributes
const updateHtmlAttributes = (lng: string) => {
    const languageCode = lng.split('-')[0];
    document.documentElement.lang = languageCode;
    document.documentElement.dir = rtlLanguages.includes(languageCode) ? 'rtl' : 'ltr';
};

// Update HTML lang and dir attributes when language changes
i18n.on('languageChanged', updateHtmlAttributes);

// Set initial lang and dir attributes after i18n is initialized
i18n.on('initialized', () => {
    updateHtmlAttributes(i18n.language);
});
if (i18n.isInitialized) {
    updateHtmlAttributes(i18n.language);
}

export default i18n;
